export class SorteioConsumidorModel {
  public seqConsumidor: number;
  public nomeConsumidor: string;
  public codSituacaoPremiacaoConsumidor: number;
  public seqSorteio: number;
  public nomeSorteio: string;
  public dataRealizacao: Date;
  public dataPrevisao: Date;
  public numPrimeiro: number;
  public numSegundo: number;
  public numTerceiro: number;
  public numQuarto: number;
  public numQuinto: number;
  public desTipoSorteio: string;
  public quantidadeBilhetes: number;
  public quantidadesComprasRealizadas: number;
  public quantidadesComprasValidas: number;
  public numSorteioPremiacaoConsumidor: number;

  public codTipoSorteio: number;
  public previsaoBilhetes: number;
  public bilhetesGerados: boolean;
  public valorTotalComprasValidas: number | null;

  public participaSorteio: number;
}



// WEBPACK FOOTER //
// ./src/app/shared/model/sorteio.consumidor.model.ts